<template>
  <div id="development" class="development">
    <div class="development-title">全部历程</div>
    <div class="development-list">
      <template v-for="item in developList">
        <div class="development-item" v-for="items in item.list" :key="items.list">
          <div class="development-date">{{ item.year }}年{{ items.date }}</div>
          <div class="development-content">
            <template v-if="Array.isArray(items.info)">
              <div v-for="itm in items.info" :key="itm" class="development-content__item">{{ itm }}</div>
            </template>
            <template v-else>
              <div class="development-content__item">{{ items.info }}</div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { Mixins } from '@ireader/core-lib';

export default {
  name: 'Development',
  mixins: [Mixins.sdd()],
  data: function () {
    return {
      developList: []
    };
  },
  mounted() {
    this.getDataSource();
  },

  methods: {
    async getDataSource() {
      try {
        const res = await this.$getSdd('zycom/develop_list');
        this.developList = res;
        this.$nextTick(() => {
          this.$emit('prepared');
        });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.development {
  width: 992px;
  margin: 0 auto;
}

.development-list {
  padding: 0px 106px;
}

.development-title {
  font-size: 40px;
  line-height: 60px;
  color: #000;
  font-weight: 500;
  text-align: center;
  padding: 48px 0;
}

.development-item {
  line-height: 32px;
  margin-top: 32px;
  &:first-child {
    margin-top: 0;
  }
}

.development-date {
  float: left;
  font-size: 18px;
  color: #000;
  font-weight: 500;
}

.development-content {
  margin-left: 158px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.development-content__item {
  display: list-item;
  list-style-type: disc;
}
.S {
  .development {
    width: auto;
    padding: 0 rem(72);
  }
  .development-content {
    color: #666;
    font-size: rem(42);
    margin-left: rem(376);
  }
  .development-list {
    padding: rem(80) 0 rem(96);
  }
  .development-title {
    padding: rem(60) 0 0;
    font-size: rem(60);
    line-height: 1;
    color: #333;
    font-weight: bold;
    text-align: left;
  }
  .development-item {
    margin-bottom: rem(24);
    line-height: 2;
  }
  .development-date {
    font-size: rem(42);
    color: #333;
  }
}
</style>
